/**
 * Getter functions for step and substep IDs
 */

/**
 * Gets the step ID from a step object.
 * Prefers `url_id` (slug-style id used by patient checkin / instant packet
 * wizards) so URLs render the human-readable segment instead of the numeric
 * primary key. Falls back to `step_id`/`id` for the onboarding wizard.
 * @param {Object} step - Step object
 * @returns {number|string} Step ID
 */
export const getStepId = (step) => step?.url_id ?? step?.step_id ?? step?.id;

/**
 * Gets the substep ID from a substep object.
 * If `url_substep_id` is explicitly defined (even as `null`, signaling the
 * substep should be omitted from the URL), it wins over numeric ids.
 * @param {Object} substep - Substep object
 * @returns {number|string|null} Substep ID
 */
export const getSubstepId = (substep) => {
  if (substep && 'url_substep_id' in substep) return substep.url_substep_id;
  return substep?.substep_id ?? substep?.id;
};
